/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {RetryBotJobRequest} from '@cash-web/protos/squareup/privacyvault/service.pb'
import {RetryBotJobResponse} from '@cash-web/protos/squareup/privacyvault/service.pb'


export const retryBotJob = (request:RetryBotJobRequest, options?: CashRequestOptions) => post<RetryBotJobRequest, RetryBotJobResponse>("/2.0/cash/retry-bot-job", request, {...options, rejectOnError: true })